import { getValueOrDash } from 'utils/data';
import { formatDateValue } from 'utils/format';

export const getDrawLabel = (drawRequest, index = 0) =>
  drawRequest.label ?? `Draw ${drawRequest.drawNumber ?? index + 1}`;

export const getDrawListData = drawRequests =>
  drawRequests.map((drawRequest, index) => ({
    id: drawRequest.id,
    label: getDrawLabel(drawRequest, index),
    requested: drawRequest.requested,
    approved: drawRequest.approved,
    status: drawRequest.status,
    inspectionStatus: drawRequest.inspectionStatus,
    requestDateLabel: getValueOrDash(formatDateValue(drawRequest.requestDate)),
  }));
